import { render, staticRenderFns } from "./TaxRulesForm.vue?vue&type=template&id=2ad6c222&"
import script from "./TaxRulesForm.vue?vue&type=script&lang=js&"
export * from "./TaxRulesForm.vue?vue&type=script&lang=js&"
import style0 from "./TaxRulesForm.vue?vue&type=style&index=0&id=2ad6c222&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports